import { Box, Checkbox, FormControl, FormControlLabel, FormGroup, FormHelperText, Typography } from '@mui/material';
import { useTranslation } from 'next-i18next';
import { ChangeEvent } from 'react';

interface IControlledCheckboxGroup {
	options: any[];
	onChange?: (value: string[]) => void;
	value: string[];
	hasError: boolean;
	dataTestIdSuffix: string;
}
export default function ControlledCheckboxGroup({
	options,
	onChange,
	value,
	hasError,
	dataTestIdSuffix,
}: IControlledCheckboxGroup) {
	const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
		if (event.target.checked) {
			onChange?.([...value, event.target.name]);
		} else {
			onChange?.(value.filter((item) => item !== event.target.name));
		}
	};
	const { t } = useTranslation('needsBasedQuestions');
	return (
		<Box sx={{ display: 'flex', mb: 2 }}>
			<FormControl
				component="fieldset"
				variant="standard"
				required
				error={hasError}
				aria-labelledby={dataTestIdSuffix}
			>
				<FormGroup>
					{options.map((option) => {
						return (
							<FormControlLabel
								key={option.value}
								control={
									<Checkbox
										color="secondary"
										checked={value?.includes(option.value)}
										onChange={handleChange}
										name={option.value}
									/>
								}
								label={
									<Typography variant="bodyMediumBook" color="text.secondary">
										{option.label}
									</Typography>
								}
							/>
						);
					})}
				</FormGroup>
				{hasError && value?.length === 0 ? (
					<FormHelperText>
						<Typography variant="errorValidation">{t('required')}</Typography>
					</FormHelperText>
				) : null}
			</FormControl>
		</Box>
	);
}
